<div class="form-group" *ngIf="checkViewMode('edit')">
    <label for="">
      <span class="red-text">{{ getTitle() }} </span>
      <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
      <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
        <i class="fa fa-question-circle"></i>
      </div>
    </label>
    <ng-select
      [class.has-error]="attribute.hasError"
      [items]="items"
      (change)="changedSelection()"
      [hideSelected]="true"
      multiple="true"
      bindLabel="Value"
      [placeholder]="getOptionByKey(attribute,'placeholder')" [(ngModel)]="selectedItems"
      [disabled]="getOptionByKey(attribute,'disabled','false')"
      [required]="getOptionByKey(attribute,'required','false')" >
    </ng-select>
</div>
<div *ngIf="checkViewMode('view')">
  <p><span class="item-title" *ngIf="getTitle()">{{ getTitle() }}: </span>
    <ng-container *ngFor="let item of selectedItems">
      <span class="selected-item-tag">{{ item.Value }}</span>
    </ng-container>
  </p>
</div>
